import { render, staticRenderFns } from "./CodePayment.vue?vue&type=template&id=45bc1e4e&"
import script from "./CodePayment.vue?vue&type=script&lang=js&"
export * from "./CodePayment.vue?vue&type=script&lang=js&"
import style0 from "./CodePayment.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45bc1e4e')) {
      api.createRecord('45bc1e4e', component.options)
    } else {
      api.reload('45bc1e4e', component.options)
    }
    module.hot.accept("./CodePayment.vue?vue&type=template&id=45bc1e4e&", function () {
      api.rerender('45bc1e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CodePayment.vue"
export default component.exports